import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IncomingCallNotificationService, IncomingCallNotification } from '../../../services/incoming-call-notification.service';

@Component({
  selector: 'app-incoming-call-notification',
  templateUrl: './incoming-call-notification.component.html',
  styleUrls: ['./incoming-call-notification.component.scss'],
  animations: [
    trigger('slideDown', [
      state('visible', style({
        transform: 'translateY(0)',
        opacity: 1
      })),
      state('hidden', style({
        transform: 'translateY(-100%)',
        opacity: 0
      })),
      transition('hidden => visible', [
        animate('300ms ease-out')
      ]),
      transition('visible => hidden', [
        animate('300ms ease-in')
      ])
    ])
  ]
})
export class IncomingCallNotificationComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  currentNotification: IncomingCallNotification | null = null;

  constructor(
    private incomingCallService: IncomingCallNotificationService
  ) {}

  ngOnInit() {
    this.incomingCallService.currentNotification$
      .pipe(takeUntil(this.destroy$))
      .subscribe(notification => {
        this.currentNotification = notification;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  async onAnswer() {
    console.log('[IncomingCallNotification] Answer button clicked');
    try {
      await this.incomingCallService.answerCall();
    } catch (error) {
      console.error('[IncomingCallNotification] Error in onAnswer:', error);
    }
  }

  async onDismiss() {
    await this.incomingCallService.dismissNotification();
  }

  getCallerDisplayName(): string {
    if (!this.currentNotification?.callerInfo) {
      return 'Intercom';
    }

    const callerInfo = this.currentNotification.callerInfo;
    
    // Try different possible caller info fields
    return callerInfo['displayName'] || 
           callerInfo['callerName'] || 
           callerInfo['remoteAddress'] || 
           callerInfo['callerNumber'] || 
           'Intercom';
  }
} 